import {useAuth} from "../../hooks/auth";
import React, {useState} from "react";
import TextField from "@material-ui/core/TextField/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Alert from "@material-ui/lab/Alert/Alert";
import {Box} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LoadingButton from "../../../Common/LoadingButton";
import {Trans, useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
  margin: {
    marginBottom: theme.spacing(1),
  },
}));


const LoginForm = ({onLogin}) => {
  const classes = useStyles();
  const { login } = useAuth();
  const [error, setError] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const {t} = useTranslation();
  const [values, setValues] = useState({
    password: '',
    username: '',
    showPassword: false
  });

  const handleSubmit = (e) => {
    e.preventDefault ();

    setError(null);
    setIsLoggingIn(true)
    login(values.username, values.password)
      .then(() => {
        onLogin();
      })
      .catch(err => {
        setError(err);
        setIsLoggingIn(false)
      })
  }

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return <form onSubmit={handleSubmit}>
    <TextField
      id="standard-multiline-flexible"
      label={t('Username')}
      value={values.username}
      onChange={handleChange('username')}
      fullWidth={true}
      className={classes.margin}
    />

    <FormControl className={classes.margin} fullWidth>
      <InputLabel htmlFor="standard-adornment-password">
        <Trans>Password</Trans></InputLabel>
      <Input
        id="standard-adornment-password"
        type={values.showPassword ? 'text' : 'password'}
        value={values.password}
        onChange={handleChange('password')}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {values.showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
    {error && <Alert severity="error">{error}</Alert>}
    <Box mb={2} mt={2}>
      <LoadingButton type='submit' variant="contained" color="primary"
                     isLoading={isLoggingIn}
                     fullWidth><Trans>Log in</Trans></LoadingButton>
    </Box>
  </form>
}

export default LoginForm;